import React from 'react';
import { DateTime } from 'luxon';
interface INullableFormattedDateProps {
    value?: Date | undefined;
    withTime?: boolean
}
const defaultProps: INullableFormattedDateProps = {
    withTime: false
};

function NullableFormattedDate(props: INullableFormattedDateProps): JSX.Element {
    const { value, withTime } = props;
    let utc_val;
    if(value != null) {
        try {
            utc_val = DateTime.fromJSDate(value, { zone: 'Europe/Oslo' });
        }
        catch {
            const valueDate = new Date(value);
            utc_val = DateTime.fromJSDate(valueDate, { zone: 'Europe/Oslo' });
        }
    }

    return (
        <>
            {utc_val
                ? withTime === true ? < span >{utc_val?.toFormat('yyyy-MM-dd HH:mm:ss')}</span> : < span >{utc_val?.toFormat('dd/MM/yyyy')}</span>
                : ' - '
            }
        </>
    );

}

NullableFormattedDate.defaultPros = defaultProps;

export default NullableFormattedDate;